import React from 'react';
import { Box, Typography, Flex } from '@fullstory/components';
import { getPercentString } from '../../../util/fmt';
import { shortNumber } from '@fullstory/util/fmt';
import { FormattedMessage } from 'react-intl';

export const svgTooltipContent = (title: string, count: number, nextCount: number) => (
  <>
    <Box marginBottom={8}>
      <Typography color="white" variant="heading5">
        {title}
      </Typography>
    </Box>
    <Flex justifyContent="flex-start" className="fs-mask">
      <Typography color="white" variant="body3">
        {getPercentString(count - nextCount, count)}
      </Typography>
      <Box margin={[0, 4, 0, 4]}>
        <Typography color="white" variant="body3">
          <FormattedMessage
            defaultMessage="·"
            description="Used as a separator e.g 10% · 100 views"
            id="G7uas+"
          />
        </Typography>
      </Box>
      <Typography color="white" variant="body3">
        {shortNumber(count - nextCount)}
      </Typography>
    </Flex>
  </>
);
